import React, { Fragment, useEffect, useState } from "react";
import { getAllClientsInvoice, getReportComplement } from "../../services/clients/clients";
import {
  Card,
  CardBody,
  Col,
  Input,
  Row,
  Table,
} from "reactstrap";
import {
  GetInvoicePpd,
  getPayForms,
  sendStampComplement,
  GetSettingsInvoice
} from "../../services/invoice/invoice";
import { validarSesion } from "../../hooks/tokens/useToken";
import { useSweetAlert } from "../../hooks/sweetAlerts/useSweetAlert";
import { useHistory, useParams } from "react-router-dom";
import FormatNumbers, { FormatAmount } from "../../utils/formatNumbers";
import { ModalComplementPayment } from "../../components/Invoice/ModalComplementPayment";
import { getAllCommercialLines } from "../../services/commercialLine/commercialLine";
import TypePersonInvoiceEnum from "../../utils/enum/type_person.enum";
import { getAllBranches } from "../../services/commercialLine/commercialLine";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';




export const IndexComplementPaymentService = () => {
  const history = useHistory();
  const { idCompany, idInvoice } = useParams();
  console.log("🚀 ~ IndexComplementPaymentService ~ idInvoice:", idInvoice)
  console.log("🚀 ~ IndexComplementPaymentService ~ company:", idCompany)
  const [createSweet] = useSweetAlert();

  const branchId = localStorage.getItem("branchId");

  const [listCommercialLines, setListCommercialLines] = useState([]);
  const [listClients, setListClients] = useState([]);
  const [isSelectedClients, setIsSelectedClients] = useState(false);
  const [clientInformation, setClientInformation] = useState(null);
  const [listInvoices, setListInvoices] = useState([]);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [listPayForms, setListPayForms] = useState([]);

  const [loadingComplement, setLoadingComplement] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [disableBtnSave, setDisableBtnSave] = useState(false);
  const [isPreComplement, setIsPreComplement] = useState(false);

  const [globalFilter, setGlobalFilter] = useState(null);
  const [expandedRows, setExpandedRows] = useState(null);
  const [datECurrentTime, setDatECurrentTime] = useState('');
  const [showPreview, setShowPreview] = useState(false);
  console.log("🚀 ~ IndexComplementPaymentService ~ showPreview:", showPreview)

  const [formComplement, setFormComplement] = useState({
    commercialLineId: "",
    companyBusinessNameId: "",
    taxRegimeId: "",
    type_person: "",
    paymentDate: "",
    paymentFormId: "",
    comments: "",
  });

  useEffect(() => {
    GetAllClients();
    GetPayForms();
    GetCommercialLines();

    const today = new Date().toISOString().split("T")[0];

    GetReportComplement(today, today);
  }, []);
  const GetAllClients = async () => {
    const listClient = await getAllClientsInvoice(true);

    if (listClient) {
      setListClients(listClient);
    }
  };

  const GetCommercialLines = async () => {
    const commercialLines = await getAllCommercialLines();
    const branches = await getAllBranches();

    const branch = branches.find(x => x.id_branch === parseInt(branchId)) ?? {};

    const _cp = branch.cp ?? null;
    const _colony = branch.colony ?? '';
    const _address = branch.address ?? '';


    if (commercialLines?.length > 0) {
      const list = commercialLines?.map((commercial) => {
        return {
          value: commercial?.id_commercial_line,
          label: commercial?.long_name,
          rfc: commercial?.rfc,
          cp: commercial?.cp,
          cpBranch: _cp,
          colony: _colony,
          address: _address,
          id_tax_regime: commercial?.id_tax_regime,
          code_tax_regime: commercial?.code_tax_regime,
          name_tax_regime: commercial?.name_tax_regime,
          type_person: commercial?.type_person
            ? TypePersonInvoiceEnum.MORAL
            : TypePersonInvoiceEnum.FISICA,
        };
      });

      setListCommercialLines(list);
    } else setListCommercialLines([]);
  };


  const GetPayForms = async () => {
    const payForms = await getPayForms();

    if (payForms?.length > 0) {
      const list = payForms?.map((form) => {
        return {
          label: form.abbreviation + " - " + form.name,
          value: form.id_pay_method,
          code: form.abbreviation,
        };
      });

      setListPayForms(list);
    } else setListPayForms([]);
  };

  const [reportComplement, setReportComplement] = useState({
    total_invoices: 0,
    total_amount: 0,
    total_clients: 0,
    date: null,
    total_cancellations: 0,
    total_preComplemento: 0
  });


  const GetReportComplement = async (start_date, end_date) => {
    const response = await getReportComplement(start_date, end_date);

    if (response) {
      setReportComplement(response);
    } else {
      setReportComplement({
        total_invoices: 0,
        total_amount: 0,
        total_clients: 0,
        date: null,
        total_cancellations: 0,
        total_preComplemento: 0
      });
    }
  };





  const GetRelatedinvoices = async (ClientId) => {
    const getListInvoices = await GetInvoicePpd(ClientId);

    if (getListInvoices?.code === 200) {
      if (getListInvoices?.data?.length > 0)
        setListInvoices(getListInvoices?.data);
    } else if (getListInvoices?.code === 401) {
      validarSesion(history, getListInvoices.code, GetRelatedinvoices);
    } else if (getListInvoices?.code === 500) {
      createSweet(
        "warning",
        "warning",
        "Obtener información del paciente",
        "Ocurrio un problema al obtener la información del paciente"
      );
    } else {
      createSweet("warning", "warning", "Orden", getListInvoices.msg);
    }
  };

  const handleCheckInvoice = (isSelected, invoice) => {
    if (isSelected) {
      setSelectedInvoices([
        ...selectedInvoices,
        {
          ...invoice,
          paymentBy: "liquided",
          amount: 0,
        },
      ]);
    } else {
      setSelectedInvoices(
        selectedInvoices.filter(
          (item) => item.id_invoice !== invoice.id_invoice
        )
      );
    }
  };

  const handleModal = (_pre) => {
    console.log("🚀 ~ handleModal ~ _pre:", _pre)
    setShowModal(!showModal);
    GetSettings(_pre)

  }

  const handleChangeType = (type, invoiceId) => {
    setSelectedInvoices(
      selectedInvoices.map((item) => {
        if (item.id_invoice === invoiceId) {
          return {
            ...item,
            paymentBy: type,
          };
        }
        return item;
      })
    );
  };

  const handleChangeAmount = (amount, invoiceId) => {
    setSelectedInvoices(
      selectedInvoices.map((item) => {
        if (item.id_invoice === invoiceId) {
          return {
            ...item,
            amount: amount,
          };
        }
        return item;
      })
    );
  };

  const handleSaveComplement = async () => {
    setLoadingComplement(true);
    setDisableBtnSave(true);


    console.log("entras");

    let errorInComplement = false;

    const body = {
      CommercialLineId: formComplement.commercialLineId,
      BranchId: branchId,
      ClientId: clientInformation?.id_company,
      ClientBusinessId: formComplement.companyBusinessNameId,
      PaymentDate: formComplement.paymentDate,
      PaymentFormCode: formComplement.paymentFormId,
      AdditionalComments: formComplement.comments,
      RelatedDocuments: selectedInvoices.map((invoice) => {

        const totalOfInvoice = invoice.total || 0;
        const totalDevolutions = invoice.total_devolutions || 0;
        const totalPaid = invoice.payment_amount || 0;

        let totalPreviousBalance = totalOfInvoice - totalDevolutions - totalPaid;
        totalPreviousBalance = FormatAmount(totalPreviousBalance, 2);

        let paidByUser = 0;
        let outsideBalance = 0;

        if (invoice.paymentBy !== "liquided") {
          paidByUser = invoice.amount || 0;
          paidByUser = isNaN(paidByUser + 1) ? 0 : parseFloat(paidByUser);

          if (paidByUser > totalPreviousBalance)
            errorInComplement = true;
          else if (paidByUser <= 0)
            errorInComplement = true;
        }

        if (invoice.paymentBy === "liquided") {
          paidByUser = totalPreviousBalance || 0;
          outsideBalance = 0;
        }
        else {
          outsideBalance = totalPreviousBalance - paidByUser;
          if (outsideBalance < 0) {
            outsideBalance = 0; // Ensure outside balance is not negative
          }
          outsideBalance = FormatAmount(outsideBalance, 2);
        }

        return {
          InvoiceId: invoice.id_invoice,
          PreviousAmount: totalPreviousBalance,
          PaymentAmount: paidByUser,
          OutsideBalance: outsideBalance,
          Partiality: invoice.parciality_number,
        };
      }),
      IsPreview: isPreComplement,
    };

    console.log("🚀 ~ handleSaveComplement ~ body:", body)


    if (errorInComplement) {
      createSweet(
        "error",
        "error",
        "Complemento de pago",
        "El monto pagado no puede ser mayor al saldo pendiente y no puede ser menor o igual a cero."
      );

      setLoadingComplement(false);
      setDisableBtnSave(false);

      return;
    }






    const sendStamp = await sendStampComplement(body);

    if (sendStamp.code === 200) {
      createSweet(
        "create",
        "info",
        "Exito!",
        "Se genero la factura con exito!"
      );

      setDisableBtnSave(false);
      setIsPreComplement(false);

      setTimeout(() => {
        window.location.href = "../../../facturacion/Emitidos";
      }, 2000);
    } else if (sendStamp.code === 401) {
      // validarSesion(history, sendStamp.code, handleSaveComplement);
      createSweet(
        "error",
        "error",
        "Factura",
        "Su sesión ha expirado, por favor vuelva a iniciar sesión"
      );
    }
    else if (sendStamp.code === 500)
      createSweet(
        "error",
        "error",
        "Factura",
        "Se perdio la conexión, con el servidor"
      );
    else if (sendStamp.code === 400)
      createSweet(
        "error",
        "error",
        "Factura",
        "No se llevo acabo la operación"
      );
    else createSweet("warning", "warning", "Factura", sendStamp.msg);

    setLoadingComplement(false);

    setDisableBtnSave(false);
  };



  const rowExpansionTemplate = (data) => {
    const columnsPerRow = 5;
    const rows = [];
    for (let i = 0; i < data.length; i += columnsPerRow) {
      rows.push(data.slice(i, i + columnsPerRow));
    }
  }




  const actionBodyTemplate = (rowData) => {
    console.log("🚀 ~ actionBodyTemplate ~ rowData:", rowData)
    return (
      <Button
        // label="Generar"
        title="Generar complemento de pago"
        icon="pi pi-file-pdf"
        className="p-button-warning"
        style={{ fontSize: '11px', padding: '5px 8px', height: '20px', width: "18px" }}
        onClick={() => {
          setIsSelectedClients(true);
          GetRelatedinvoices(rowData?.id_company);
          setClientInformation(rowData);
        }}
      />
    );
  };

  // *

  useEffect(() => {
    const loadData = async () => {

      if (!idCompany) return;

      setIsSelectedClients(true);

      GetRelatedinvoices(idCompany);
      console.log("🚀 ~ loadData ~ idCompany:", idCompany)
      GetPayForms();
      GetCommercialLines();

      const clients = await getAllClientsInvoice(true);
      console.log("🚀 ~ loadData ~ clients:", clients)

      // // 🔍 buscar empresa
      const companyFound = clients.find(
        c => String(c.id_company) === String(idCompany)
      );

      if (companyFound) {
        setClientInformation(companyFound);
      }
    };

    loadData();
  }, [idCompany]);



  useEffect(() => {
    if (showPreview) {
      const ahora = new Date();
      const dia = String(ahora.getDate()).padStart(2, '0');
      const mes = String(ahora.getMonth() + 1).padStart(2, '0');
      const anio = ahora.getFullYear();
      const hora = String(ahora.getHours()).padStart(2, '0');
      const minuto = String(ahora.getMinutes()).padStart(2, '0');
      const segundo = String(ahora.getSeconds()).padStart(2, '0');

      setDatECurrentTime(`${dia}-${mes}-${anio} ${hora}:${minuto}:${segundo}`);
    }
  }, [showPreview]);

  const [listSettings, setListSettings] = useState([])

  // ? CONFIGURATION SETTINGS
  const GetSettings = async (_pre) => {

    const settings = await GetSettingsInvoice(branchId, _pre, 2);

    if (settings?.data.length > 0) {
      const list = settings?.data.map((form) => {
        return {
          branch: form.branch,
          serie: form.serie,
        };
      });

      setListSettings(list);
    } else setListSettings([]);
  };


  // ? CONFIGURATION DATATABLE
  const headerStyle =
  {
    backgroundColor: "#1d5b83",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "13px",
    borderRight: "1px solid #fff",
    borderBottom: "2px solid #fff",
  };

  const cellStyle =
  {
    fontSize: "13px",
    padding: "5px",
    textAlign: "center",
    fontFamily: "Montserrat, sans-serif",
  };






  const creditDaysMap = {
    0: 0,
    1: 0,
    2: 2,
    3: 7,
    4: 8,
    5: 9,
    6: 15,
    7: 30,
    8: 45,
    9: 60,
    10: 90
  };

  const renderCreditDays = (rowData) => {
    const days = creditDaysMap[rowData.credit_days] ?? 0;

    const severity =
      days === 0 ? "danger" :
        days <= 7 ? "primary" :
          days <= 15 ? "warning" :
            days <= 30 ? "info" :
              "success";

    return (
      <Tag
        severity={severity}
        value={`${days} días`}
        style={{
          fontSize: "11px",
          padding: "2px 6px",
          lineHeight: "1",
          minWidth: "auto"
        }}
      />
    );
  };

  const today = new Date();
  const todayDate = [
    today.getFullYear(),
    String(today.getMonth() + 1).padStart(2, "0"),
    String(today.getDate()).padStart(2, "0"),
  ].join("-");


  // * --------
  const invoiceUuidBody = (invoice) => (
    <span
      title={invoice?.uuid ?? ""}
      style={{
        display: "inline-block",
        maxWidth: "190px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
      }}
    >
      {invoice?.uuid ?? "---"}
    </span>
  );

  const centerStyle = {
    ...cellStyle,
    textAlign: "center",
    zIndex: 2
  };




  const invoiceCheckboxBody = (invoice) => (
    <div className="d-flex justify-content-center align-items-center">
      <Input
        type="checkbox"
        checked={
          selectedInvoices?.some(
            (inv) =>
              Number(inv?.id_invoice) ===
              Number(invoice?.id_invoice)
          ) ?? false
        }
        onChange={(e) =>
          handleCheckInvoice(e.target.checked, invoice)
        }
      />
    </div>
  );

  const invoiceIconBody = () => (
    <img
      alt="Laboratorio"
      className="img-fluid"
      src={require("../../assets/images/flask_laboratory.svg")}
      style={{
        width: "30px",
        height: "30px",
        objectFit: "contain",
      }}
    />
  );

  const invoiceSerieBody = (invoice) =>
    `${invoice?.serie ?? ""} ${invoice?.folio ?? ""}`.trim() || "---";

  const invoiceDateBody = (invoice) =>
    invoice?.date ?? "---";

  const invoiceMethodBody = (invoice) =>
    invoice?.name_type_method ?? "---";

  const invoicePartialityBody = (invoice) =>
    invoice?.parciality_number ?? 1;

  const invoiceTotalBody = (invoice) =>
    `$ ${FormatAmount(invoice?.total ?? 0, 2)}`;

  const invoiceDevolutionsBody = (invoice) =>
    `$ ${FormatAmount(invoice?.total_devolutions ?? 0, 2)}`;

  const invoicePaymentBody = (invoice) =>
    `$ ${FormatAmount(invoice?.payment_amount ?? 0, 2)}`;

  const invoiceBalanceBody = (invoice) =>
    `$ ${FormatAmount(invoice?.outside_balance ?? 0, 2)}`;

  // const invoiceUuidBody = (invoice) => (
  //   <span
  //     title={invoice?.uuid ?? ""}
  //     style={{
  //       display: "inline-block",
  //       maxWidth: "190px",
  //       overflow: "hidden",
  //       textOverflow: "ellipsis",
  //       whiteSpace: "nowrap",
  //       verticalAlign: "middle",
  //     }}
  //   >
  //     {invoice?.uuid ?? "---"}
  //   </span>
  // );




  //* ----


  return (
    <Fragment>
      <div  >

        <Card>


          {!isSelectedClients && (
            <>
              <div className='container-global-zoom-Overdue'>
                <div style={{ paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "111%", transformOrigin: "top left", textAlign: "center", height: "20%" }}>
                  <Card style={{
                    marginBottom: '15px',
                    background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                    border: 'none',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                  }}>
                    <CardBody style={{ padding: '18px 25px' }}>
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center w-100">
                          <div style={{
                            width: '50px',
                            height: '50px',
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginRight: '15px'
                          }}>
                            <img
                              alt="flask"
                              className="img-fluid text-info mr-2"
                              src={require("../../assets/images/laboratory-External/report-cxc.svg")}
                              style={{ width: "80px", height: "80px" }}
                            />
                          </div>

                          <div style={{ width: '100%' }}>
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              marginBottom: '10px'
                            }}>

                              <h4
                                style={{
                                  color: '#fff',
                                  fontWeight: 700,
                                  fontSize: '20px',
                                  margin: 0
                                }}
                              >
                                Complementos de pago
                              </h4>

                              <div style={{
                                marginLeft: 'auto',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                background: 'rgba(255,255,255,0.08)',
                                padding: '6px 12px',
                                borderRadius: '12px',
                                color: '#fff',
                                fontSize: '12px',
                                fontWeight: 600
                              }}>
                                <i className="fa fa-calendar" />

                                <span>Periodo:</span>

                                <span style={{ fontWeight: 700 }}>
                                  {todayDate}
                                </span>

                                <span>-</span>

                                <span style={{ fontWeight: 700 }}>
                                  {todayDate}
                                </span>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>

                    </CardBody>

                  </Card>



                  <Card className='shadow-sm border height-equal pricingtable mb-0 pb-0' style={{ paddingTop: "1px", paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "111%", transformOrigin: "top left", textAlign: "center", height: "95%" }}>
                    <Col sm="12" className='pt-3'>
                      <Row>
                        <Col sm="12">
                          <div style={{
                            marginTop: '1px',
                          }}>
                            <Col sm="12" className='p-l-0 p-r-0' >
                              {
                                // * DASHBOARD CONFIGURATION INDICADORES
                              }
                              <div className="mb-3"
                                style={{
                                  display: 'flex',
                                  gap: '12px',
                                  overflowX: 'auto'
                                }}>
                                <div style={{ minWidth: '220px', flex: '1' }}>
                                  <div className={`card dashboard-card-overduel `}>
                                    <div className="d-flex justify-content-between align-items-start">
                                      <span className="card-title-overduel">Total de clientes</span>
                                      <span className="trend-overduel up-overduel">
                                        <i className={`fa fa-users f-30 `}></i>
                                      </span>
                                    </div>

                                    <h2 className="card-value-overduel text-primary">
                                      {reportComplement.total_clients}
                                    </h2>

                                    <div className="card-sub-overduel">Clientes</div>
                                    {/* <div className="sparkline-overduel"></div> */}
                                  </div>
                                </div>

                                <div style={{ minWidth: '240px', flex: '1.2' }}>
                                  <div className={`card dashboard-card-overduel `}>
                                    <div className="d-flex justify-content-between">
                                      <span className="card-title-overduel">Monto pagado</span>
                                      <span className="trend-overduel down-overduel">
                                        <i className={`fa fa-calendar-check-o f-30 txt-warning f-30 `}></i>
                                      </span>
                                    </div>

                                    <h2 className="card-value-overduel">
                                      {Number(reportComplement.total_amount).toLocaleString("es-MX", {
                                        style: "currency",
                                        currency: "MXN",
                                      })}
                                    </h2>

                                    <div className="card-sub-overduel">MXN</div>
                                  </div>
                                </div>




                                <div style={{ minWidth: '220px', flex: '1' }}>
                                  <div className={`card dashboard-card-overduel `}>
                                    <div className="d-flex justify-content-between align-items-start">
                                      <span className="card-title-overduel">Total de complementos</span>
                                      <span className="trend-overduel up-overduel">
                                        <i className={`fa fa-file-pdf-o  f-30 `}></i>
                                      </span>
                                    </div>

                                    <h2 className="card-value-overduel text-primary">
                                      {reportComplement.total_invoices}
                                    </h2>

                                    <div className="card-sub-overduel">Facturas</div>
                                  </div>
                                </div>




                                <div style={{ minWidth: '240px', flex: '1.2' }}>

                                  <div className={`card dashboard-card-overduel  ${Number((reportComplement.total_cancellations || "0").toString().replace(/,/g, '')) > 0
                                    ? 'card-danger-overduel'
                                    : ''}   `}>
                                    <div className="d-flex justify-content-between">
                                      <span className="card-title-overduel">Total de complementos cancelados</span>
                                      <span className="trend-overduel down-overduel">
                                        <i className="fa fa-file-pdf-o f-30"></i>
                                      </span>
                                    </div>

                                    <h2 className="card-value-overduel text-danger">
                                      {`${(reportComplement.total_cancellations)}`}
                                    </h2>

                                    <div className="card-sub-overduel">Facturas</div>
                                  </div>
                                </div>




                                <div style={{ minWidth: '240px', flex: '1.2' }}>

                                  <div className={`card dashboard-card-overduel  ${Number((reportComplement.total_preComplemento || "0").toString().replace(/,/g, '')) > 0
                                    ? 'card-success-overduel'
                                    : ''}   `}>
                                    <div className="d-flex justify-content-between">
                                      <span className="card-title-overduel">Total de precomplementos</span>
                                      <span className="trend-overduel down-overduel">
                                        <i className={`fa fa-file-pdf-o f-30 txt-warning `}></i>
                                      </span>
                                    </div>

                                    <h2 className="card-value-overduel text-warning">
                                      {`${(reportComplement.total_preComplemento)}`}
                                    </h2>

                                    <div className="card-sub-overduel">Facturas</div>
                                  </div>
                                </div>



                              </div>
                            </Col>

                            <Col sm="12" className="pl-0 pr-0 mt-2 " >
                              <h6 className="mb-1"> GESTION DE CLIENTES</h6>
                              <CardBody className="pb-5 pl-0 pr-0" style={{ padding: "16px" }}>
                                <div style={{
                                  display: "flex",
                                  alignItems: "end",
                                  gap: "12px",
                                  flexWrap: "wrap"
                                }}>
                                  <Col sm="12" className=' ' >
                                    <Row>
                                      <Col sm="10">
                                      </Col>
                                      <Col sm="2">
                                        <InputText
                                          type="search"
                                          placeholder="Buscar..."
                                          onInput={(e) => setGlobalFilter(e.target.value)}
                                          className="p-inputtext-sm"
                                        />
                                      </Col>
                                    </Row>


                                  </Col>

                                  <Col sm="12" className='pt-3'>
                                    <div className="table-responsive" >

                                      <DataTable
                                        className="data-table"
                                        value={listClients}
                                        expandedRows={expandedRows}
                                        onRowToggle={(e) => setExpandedRows(e.data)}
                                        rowExpansionTemplate={rowExpansionTemplate}
                                        paginator
                                        stripedRows
                                        rows={10}
                                        rowsPerPageOptions={[10, 30, 50, 90, 150]}
                                        globalFilter={globalFilter}
                                        responsiveLayout="scroll"
                                      >
                                        <Column
                                          body={(rowData, { rowIndex }) => rowIndex + 1}
                                          header="#"
                                          headerStyle={{ ...headerStyle, textAlign: "center" }}
                                          style={{ ...cellStyle, textAlign: "center" }}
                                          sortable
                                          field="id_company"
                                        />
                                        <Column
                                          field="bussines_name"
                                          header="Razón Social"
                                          sortable
                                          headerStyle={{ ...headerStyle, textAlign: "center" }}
                                          style={{ ...cellStyle, textAlign: "center" }}
                                        />
                                        <Column
                                          field="name"
                                          header="Cliente"
                                          sortable
                                          headerStyle={{ ...headerStyle, textAlign: "center" }}
                                          style={{ ...cellStyle, textAlign: "center" }}
                                        />
                                        <Column
                                          field="rfc"
                                          header="RFC"
                                          sortable
                                          headerStyle={{ ...headerStyle, textAlign: "center" }}
                                          style={{ ...cellStyle, textAlign: "center" }}
                                        />

                                        <Column
                                          field="credit_days"
                                          header="Días de crédito"
                                          body={renderCreditDays}
                                          sortable
                                          headerStyle={{ ...headerStyle, textAlign: "center" }}
                                          style={{ ...cellStyle, textAlign: "center" }}
                                        />






                                        <Column
                                          body={actionBodyTemplate}
                                          header="Acción"
                                          headerStyle={{ ...headerStyle, textAlign: "center" }}
                                          style={{ ...cellStyle, textAlign: "center" }}
                                        />
                                      </DataTable>
                                    </div>

                                  </Col>

                                </div>

                              </CardBody>

                            </Col>

                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Card>
                </div>

              </div>
            </>
          )}

          {isSelectedClients && (
            <>
              <Col sm="12" md="12" lg="12" className='container-global-zoom'>
                <Card style={{ textAlign: "left" }} className="height-equal pricingtable pt-0 pb-0 pr-0 pl-0">
                  <Col sm="12">
                    <Col sm="12" md="12" lg="12" className="text-right">
                      <Button
                        color="dark"
                        className="m-2 rounded pb-1 pt-1 pl-1 pr-1"
                        style={{ fontSize: "12px" }}
                        size="xs"
                        onClick={() => {

                          if (idCompany) {
                            history.push(`../../../facturas/vencidas`);
                            return;
                          }

                          setIsSelectedClients(false);
                          setSelectedInvoices([]);
                          setClientInformation(null);
                          setListInvoices([]);
                          setGlobalFilter(null);
                        }}
                      >
                        <span className="fa fa-filter"></span> Volver a los clientes
                      </Button>
                    </Col>
                  </Col>
                  <CardBody className="pl-3 pr-3 pt-3 pb-3" >
                    <h6 className={idCompany === undefined ? "txt-info f-w-600" : "d-none"} >
                      {`${clientInformation?.bussines_name}`}
                      <br />
                      <label style={{ color: "#000000", fontSize: "12px" }} >RFC:  {`${clientInformation?.rfc}`}</label>
                    </h6> <br /> <br />

                    <h6 className={idCompany === undefined ? "d-none" : "txt-info f-w-600"} >

                      <label style={{ color: "#01479d", fontSize: "18px" }} >Cliente:  {`${clientInformation?.bussines_name}`}</label>
                      <br />
                      <label style={{ color: "#000000", fontSize: "12px" }} >RFC:  {`${clientInformation?.rfc}`}</label>
                    </h6>




                    <Row>
                      <Col sm="12" md="12" lg="12" className="text-right">
                        {selectedInvoices?.length > 0 && (
                          <div>
                            <Button
                              style={{
                                fontSize: "12px",
                                backgroundColor: "#D97706",
                                borderColor: "#ff9800",
                                color: "#fff"
                              }}
                              color="warning"
                              className="m-2 rounded pb-1 pt-1 pl-1 pr-1"
                              size="sm"
                              onClick={() => {
                                handleModal(true);
                                setLoadingComplement(true);
                                setIsPreComplement(false);
                                setTimeout(() => {
                                  setLoadingComplement(false);
                                }, 2000);
                              }}
                            >
                              {" "}
                              Complemento de pago
                            </Button>
                            <Button
                              style={{
                                fontSize: "12px",
                                backgroundColor: "#cad906",
                                borderColor: "#c8d42a",
                                color: "#fff"
                              }}
                              color="info"
                              className="m-2 rounded pb-1 pt-1 pl-1 pr-1"
                              size="sm"
                              onClick={() => {
                                handleModal(false);
                                setLoadingComplement(true);
                                setIsPreComplement(true);
                                setTimeout(() => {
                                  setLoadingComplement(false);
                                }, 2000);
                              }}
                            >
                              {" "}
                              Pre Complemento de pago
                            </Button>
                          </div>
                        )}
                      </Col>
                      <Col sm="12" md="12" lg="12">
                        <div className="table-responsive">
                          {listInvoices?.length === 0 && (
                            <div className="text-center">
                              <div
                                style={{ textAlign: "-webkit-center" }}
                                className="d-block"
                              >
                                `{" "}
                                <img
                                  className="img-fluid"
                                  src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                  style={{ width: "32%" }}
                                  alt=""
                                />
                              </div>
                              <p className="f-w-600 f-14 badge badge-light-primary">
                                No hay facturas pendientes por pagar
                              </p>
                            </div>
                          )}

                          {
                            listInvoices?.length > 0 && (
                              <DataTable
                                value={listInvoices ?? []}
                                paginator
                                rows={10}
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                responsiveLayout="scroll"
                                className="p-datatable-sm invoice-related-table"
                                dataKey="id_invoice"
                                rowClassName={(invoice) =>
                                  idInvoice !== undefined &&
                                    Number(invoice?.id_invoice) === Number(idInvoice)
                                    ? "invoice-current-row"
                                    : ""
                                }
                                emptyMessage={
                                  <div className="text-center py-5">
                                    <img
                                      src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                      style={{
                                        width: "250px",
                                        maxWidth: "45%",
                                        opacity: 0.8,
                                      }}
                                      alt="Sin resultados"
                                    />
                                    <p
                                      className="mt-3 mb-0"
                                      style={{
                                        fontSize: "14px",
                                        color: "#6c757d",
                                      }}
                                    >
                                      No se encontraron facturas.
                                    </p>
                                  </div>
                                }
                              >
                                <Column
                                  header=""
                                  body={invoiceCheckboxBody}
                                  headerStyle={{
                                    backgroundColor: "#0d3b59",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                    padding: "5px",
                                  }}
                                  bodyStyle={centerStyle}
                                  style={{ width: "45px" }}
                                />

                                <Column
                                  header=""
                                  body={invoiceIconBody}
                                  headerStyle={{
                                    backgroundColor: "#0d3b59",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                    padding: "5px",
                                  }}
                                  bodyStyle={centerStyle}
                                  style={{ width: "55px" }}
                                />

                                <Column
                                  field="folio"
                                  header="SERIE/FOLIO"
                                  body={invoiceSerieBody}
                                  sortable
                                  headerStyle={{
                                    backgroundColor: "#0d3b59",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                    padding: "5px",
                                  }}
                                  bodyStyle={centerStyle}
                                />

                                <Column
                                  field="date"
                                  header="FECHA"
                                  body={invoiceDateBody}
                                  sortable
                                  headerStyle={{
                                    backgroundColor: "#0d3b59",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                    padding: "5px",
                                  }}
                                  bodyStyle={centerStyle}
                                />

                                <Column
                                  field="name_type_method"
                                  header="MÉTODO DE PAGO"
                                  body={invoiceMethodBody}
                                  sortable
                                  headerStyle={{
                                    backgroundColor: "#0d3b59",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                    padding: "5px",
                                  }}
                                  bodyStyle={centerStyle}
                                />

                                <Column
                                  field="parciality_number"
                                  header="PARCIALIDAD"
                                  body={invoicePartialityBody}
                                  headerStyle={{
                                    backgroundColor: "#0d3b59",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                    padding: "5px",
                                  }}
                                  bodyStyle={centerStyle}
                                />

                                <Column
                                  field="total"
                                  header="TOTAL"
                                  body={invoiceTotalBody}
                                  sortable
                                  headerStyle={{
                                    backgroundColor: "#0d3b59",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                    padding: "5px",
                                  }}
                                  bodyStyle={centerStyle}
                                />

                                <Column
                                  field="total_devolutions"
                                  header="DEV/DESCUENTOS"
                                  body={invoiceDevolutionsBody}
                                  headerStyle={{
                                    backgroundColor: "#0d3b59",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                    padding: "5px",
                                  }}
                                  bodyStyle={centerStyle}
                                />

                                <Column
                                  field="payment_amount"
                                  header="MONTO PAGADO"
                                  body={invoicePaymentBody}
                                  sortable
                                  headerStyle={{
                                    backgroundColor: "#0d3b59",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                    padding: "5px",
                                  }}
                                  bodyStyle={centerStyle}
                                />

                                <Column
                                  field="outside_balance"
                                  header="SALDO"
                                  body={invoiceBalanceBody}
                                  headerStyle={{
                                    backgroundColor: "#0d3b59",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                    padding: "5px",
                                  }}
                                  bodyStyle={centerStyle}
                                />

                                <Column
                                  field="uuid"
                                  header="UUID"
                                  body={invoiceUuidBody}
                                  headerStyle={{
                                    backgroundColor: "#0d3b59",
                                    color: "#fff",
                                    fontWeight: "bold",
                                    fontSize: "10px",
                                    padding: "5px",
                                  }}
                                  bodyStyle={centerStyle}
                                />
                              </DataTable>
                            )
                          }
                        </div>
                      </Col>
                    </Row>
                    <br /><br /><br /><br />
                  </CardBody>
                </Card>
              </Col>
            </>
          )}
        </Card>

      </div>

      {showModal && (
        <ModalComplementPayment
          loadingPreview={loadingComplement}
          showPreviewInvoice={showModal}
          handlePreviewInvoice={handleModal}
          listInvoices={selectedInvoices}
          handleChangeType={handleChangeType}
          handleChangeAmount={handleChangeAmount}
          clientInformation={clientInformation}
          formComplement={formComplement}
          setFormComplement={setFormComplement}
          listPayForms={listPayForms}
          listCommercialLines={listCommercialLines}
          handleSaveComplement={handleSaveComplement}
          disbleButton={disableBtnSave}
          datECurrentTime={datECurrentTime}
          setDatECurrentTime={setDatECurrentTime}
          showPreview={showPreview}
          setShowPreview={setShowPreview}
          serie={listSettings}

        />
      )}
    </Fragment>
  );
};
